import { useAuthStore } from '@/app/store/authStore';

// Thin façade over the auth store. Components depend on this hook
// rather than importing useAuthStore directly, so the underlying state
// manager (Zustand today) can change without touching every consumer.
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const login = useAuthStore((s) => s.login);
  const logout = useAuthStore((s) => s.logout);
  const currentOrganization = useAuthStore((s) => s.currentOrganization);
  const isPlatformAdmin = useAuthStore((s) => s.isPlatformAdmin);

  return {
    user,
    currentOrganization,
    isPlatformAdmin,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'idle' || status === 'authenticating',
    login,
    logout,
  };
}
